import React from 'react';
import { getDic } from '../../assets/i18n/dictionary';
import {
  FormRow,
  FormColumn,
  TextSmall,
  CameraScanOffline,
} from '../../components';

const CameraScanProp = (props) => {
  const {
    params,
    dimensions,
    tryDetectFace,
    labeledFaceDescriptors,
    useBackCamera = false,
  } = props;

  const width = dimensions.width < 820 ? dimensions.width - 10 : 800;
  const height = dimensions.height < 820 ? dimensions.height - 10 : 800;

  const [currentLog, setCurrentLog] = React.useState('');

  return (
    <FormColumn
      height={dimensions.height - (params?.public === 'true' ? 1 : 70)}
      justifyContent='center'
    >
      <FormRow justifyContent='center'>
        <CameraScanOffline
          width={width}
          height={height}
          onFaceDetect={i => tryDetectFace(i)}
          labeledFaceDescriptors={labeledFaceDescriptors}
          useBackCamera={useBackCamera}
          log={i => setCurrentLog(i)}
        />
      </FormRow>
    </FormColumn>
  )
};

export default CameraScanProp;
